import * as fromDirectOnboarding from "../actions/direct-onboarding.actions";
import { DirectOnboardingConfig } from "../../services/uwl/uwl.service";

export const FEATURE_KEY = "directOnboardingConfigs";

export interface DirectOnboardingConfigState {
  entities: { [id: string]: DirectOnboardingConfig };
  loading: boolean;
  loaded: boolean;
}

export const initialState: DirectOnboardingConfigState = {
  entities: {},
  loading: false,
  loaded: false,
};

export function reducer(
  state = initialState,
  action: fromDirectOnboarding.DirectOnboardingActions,
): DirectOnboardingConfigState {
  switch (action.type) {
    case fromDirectOnboarding.DELETE_DIRECT_ONBOARDING_CONFIG:
    case fromDirectOnboarding.UPDATE_DIRECT_ONBOARDING_CONFIG:
    case fromDirectOnboarding.CREATE_DIRECT_ONBOARDING_CONFIG:
    case fromDirectOnboarding.LOAD_DIRECT_ONBOARDING_CONFIGS: {
      return {
        ...state,
        loading: true,
      };
    }

    case fromDirectOnboarding.LOAD_DIRECT_ONBOARDING_CONFIGS_SUCCESS: {
      const configs = action.payload;
      const entities = configs.reduce(
        (acc: { [id: string]: DirectOnboardingConfig }, config: DirectOnboardingConfig) => {
          return { ...acc, [config.id]: config };
        },
        {},
      );
      return {
        ...state,
        loading: false,
        loaded: true,
        entities,
      };
    }

    case fromDirectOnboarding.UPDATE_DIRECT_ONBOARDING_CONFIG_SUCCESS:
    case fromDirectOnboarding.CREATE_DIRECT_ONBOARDING_CONFIG_SUCCESS: {
      const config = action.payload;
      const entities = {
        ...state.entities,
        [config.id]: config,
      };
      return {
        ...state,
        entities,
        loading: false,
        loaded: true,
      };
    }

    case fromDirectOnboarding.DELETE_DIRECT_ONBOARDING_CONFIG_SUCCESS: {
      const config = action.payload;
      const { [config.id]: removed, ...entities } = state.entities;
      return {
        ...state,
        entities,
      };
    }

    case fromDirectOnboarding.DELETE_DIRECT_ONBOARDING_CONFIG_FAIL:
    case fromDirectOnboarding.UPDATE_DIRECT_ONBOARDING_CONFIG_FAIL:
    case fromDirectOnboarding.CREATE_DIRECT_ONBOARDING_CONFIG_FAIL:
    case fromDirectOnboarding.LOAD_DIRECT_ONBOARDING_CONFIGS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }
  }
  return state;
}

export const getDirectOnboardingConfigEntities = (state: DirectOnboardingConfigState) =>
  state.entities;
